import { combineReducers } from "redux";
import alert from "../reducers/alert";
import user from "../reducers/user";

export default combineReducers({
  alert,
  user,
});
